import { render, staticRenderFns } from "./mainRelations.vue?vue&type=template&id=03dea4e8"
import script from "./mainRelations.vue?vue&type=script&lang=js"
export * from "./mainRelations.vue?vue&type=script&lang=js"
import style0 from "./mainRelations.vue?vue&type=style&index=0&id=03dea4e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports